var map = {
	"./amplify-amazon-button_5.entry.js": [
		"77e1",
		"chunk-09b6d7da"
	],
	"./amplify-auth-fields_9.entry.js": [
		"2689",
		"chunk-5203cb7e"
	],
	"./amplify-authenticator.entry.js": [
		"b836",
		"chunk-ce47a23c",
		"chunk-2d2105ef"
	],
	"./amplify-button_3.entry.js": [
		"efa9",
		"chunk-5f1bc134"
	],
	"./amplify-chatbot.entry.js": [
		"9b2c",
		"chunk-406fd860"
	],
	"./amplify-checkbox.entry.js": [
		"db86",
		"chunk-2d228cf2"
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		"e862",
		"chunk-ce47a23c",
		"chunk-2d226365"
	],
	"./amplify-container.entry.js": [
		"a72f",
		"chunk-2d208de0"
	],
	"./amplify-federated-buttons_2.entry.js": [
		"644c",
		"chunk-7dbe6352"
	],
	"./amplify-federated-sign-in.entry.js": [
		"a81f",
		"chunk-35d5ca8f"
	],
	"./amplify-form-field_4.entry.js": [
		"f988",
		"chunk-2d22dbc9"
	],
	"./amplify-greetings.entry.js": [
		"57dd",
		"chunk-0195b406"
	],
	"./amplify-icon-button.entry.js": [
		"182d",
		"chunk-2d0abfcf"
	],
	"./amplify-icon.entry.js": [
		"b8f5",
		"chunk-e5bcde22"
	],
	"./amplify-link.entry.js": [
		"f482",
		"chunk-2d22c8fe"
	],
	"./amplify-nav_2.entry.js": [
		"23a0",
		"chunk-7f606622"
	],
	"./amplify-photo-picker.entry.js": [
		"c4f1",
		"chunk-3660a8d0"
	],
	"./amplify-picker.entry.js": [
		"d040",
		"chunk-3661081c"
	],
	"./amplify-radio-button_2.entry.js": [
		"a4b9",
		"chunk-ce47a23c",
		"chunk-2d208840"
	],
	"./amplify-s3-album.entry.js": [
		"4e6f",
		"chunk-097f4b3c"
	],
	"./amplify-s3-image-picker.entry.js": [
		"b90a",
		"chunk-4a12f74a"
	],
	"./amplify-s3-image.entry.js": [
		"76ad",
		"chunk-7bc0297f"
	],
	"./amplify-s3-text-picker.entry.js": [
		"5af2",
		"chunk-04dbc28b"
	],
	"./amplify-s3-text.entry.js": [
		"dce0",
		"chunk-3c79df79"
	],
	"./amplify-select-mfa-type.entry.js": [
		"fef4",
		"chunk-b215baa4"
	],
	"./amplify-sign-in-button.entry.js": [
		"7358",
		"chunk-f96b8456"
	],
	"./amplify-toast.entry.js": [
		"05e3",
		"chunk-2d0a4629"
	],
	"./amplify-tooltip.entry.js": [
		"1faa",
		"chunk-2d0b722b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "521b";
module.exports = webpackAsyncContext;